import moment from 'moment';
import React, { FC } from 'react';
import { Control, Controller } from 'react-hook-form';
import RRuleGenerator from 'react-rrule-generator';
import RRule from 'rrule';

export const CustomRRuleGenerator: FC<{
  startDate?: string
  control: Control
  disabled?: boolean
}> = ({ startDate, control, disabled }) => (
  <div className="rrule">
    <Controller
      control={control}
      defaultValue="FREQ=DAILY"
      name="RRule"
      className="abc"
      render={({ value, onChange }) => (
        <RRuleGenerator
          value={value}
          onChange={onChange}
          config={{
            repeat: ['Yearly', 'Monthly', 'Weekly', 'Daily'],
          }}
          disabled={disabled}
        />
      )}
      rules={{
        required: true,
        validate: (val: any) => {
          const eventRrule = RRule.fromString(val);
          if (eventRrule.origOptions.freq === 2 && !eventRrule.origOptions.byweekday) {
            return 'Please select at least one day when repeating weekly'
          }
          if (eventRrule.origOptions.count < 1) {
            return 'Must have at least one occurrence'
          }

          if (eventRrule.origOptions.until && startDate) {
            const input = moment(startDate);
            const until = moment(eventRrule.origOptions.until);
            if (input >= until) {
              return 'End date must be later than the start date';
            }
          }
          return true;
        },
      }}
    />
  </div>
);
